<template>
  <!-- 角色管理 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="system"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="system" leftIndex="role"></LeftSideBar>
    </div>
    <div id="rolepart" class="base-content">
      <div class="rolepart-left">
        <div class="button-box">
          <el-button
            type="text"
            icon="el-icon-plus"
            size="small"
            @click="firstCreateRole"
            >新增</el-button
          >
          <el-button
            type="text"
            icon="el-icon-edit"
            size="small"
            @click="firstEditRole"
            >编辑</el-button
          >
          <el-button
            type="text"
            icon="el-icon-delete"
            size="small"
            @click="deleteRolePre"
            >删除</el-button
          >
        </div>

        <div class="role-list">
          <div class="rolepart-left-title">
            <i class="el-icon-s-custom"> </i>&nbsp; 角色列表
          </div>

          <div class="role-list-detail">
            <ul>
              <li
                class="role-item"
                v-for="(item, index) in roleList"
                :key="item.roleName"
                :class="{ active: index === isactive }"
                @click="applyUserList(index, item)"
              >
                <span class="list-span"></span
                ><i class="el-icon-user"></i>&nbsp;
                <span class="list-name" :title="item.roleName">{{
                  item.roleName
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="rolepart-right">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="first">
            <!-- 基本信息 -->
            <div v-show="getRole.id">
              <div class="usertabledata">
                <el-button
                  @click="addUserByRole"
                  icon="el-icon-plus"
                  type="text"
                  size="small"
                >
                  添加用户到角色</el-button
                >
                <el-button
                  @click="deleteUserPre"
                  icon="el-icon-minus"
                  type="text"
                  size="small"
                >
                  从角色中删除用户</el-button
                >
              </div>
              <el-table
                style="width: 100%"
                border
                :data="tableData"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                @selection-change="handleTableSelectionChange"
              >
                <el-table-column
                  type="selection"
                  width="55"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="username"
                  show-overflow-tooltip
                  label="用户名"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="realName"
                  show-overflow-tooltip
                  label="真实姓名"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="phone"
                  show-overflow-tooltip
                  label="电话"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="dept.deptName"
                  show-overflow-tooltip
                  label="所属机构"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <!-- 分页组件 -->
              <div class="pagination-box">
                <el-pagination
                  :total="totalSize1"
                  :current-page="currentPage1"
                  :page-size="pageSize1"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 50, 100, 200]"
                  layout="total, sizes, prev, pager, next, jumper"
                >
                </el-pagination>
              </div>
            </div>
            <div v-show="!getRole.id" class="tip-text">请选择具体角色</div>
          </el-tab-pane>
          <el-tab-pane label="菜单权限" name="second" class="roleMenuBox">
            <div v-show="!getRole.id" class="tip-text">请选择具体角色</div>
            <div v-show="getRole.id">
              <div class="upbutton">
                <el-button
                  type="primary"
                  icon="el-icon-s-older"
                  size="small"
                  @click="RightsSave('menu')"
                  style="margin-right:'20px'"
                  >保存</el-button
                >
                <!-- 全选 -->
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAllMenus"
                  @change="handleCheckAllRightsMenus"
                  >全选</el-checkbox
                >
              </div>
              <div class="downContent">
                <el-tree
                  :data="menuTree"
                  node-key="id"
                  highlight-current
                  :expand-on-click-node="false"
                  :default-expand-all="true"
                  :default-checked-keys="checkedKey"
                  ref="menuRightTree"
                  show-checkbox
                  :props="defaultMenuProps"
                >
                </el-tree>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 新增角色弹窗 -->
    <el-dialog
      title="新增角色"
      center
      :visible.sync="createRoleDialog"
      width="600px"
      @close="clearForm('addRoleForm')"
      custom-class="add-dialog"
    >
      <el-form ref="addRoleForm" :model="addRoleForm" :rules="addRoleFormRules">
        <el-form-item label="角色名称" label-width="80px" prop="roleName">
          <el-input
            v-model="addRoleForm.roleName"
            autocomplete="off"
            placeholder="请填写角色名称"
          ></el-input> </el-form-item
        ><br />

        <el-form-item label="备注" label-width="80px">
          <el-input
            v-model="addRoleForm.remark"
            autocomplete="off"
            placeholder="请填写备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createRole('addRoleForm')"
          >确 定</el-button
        >
        <el-button @click="createRoleDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑角色弹窗 -->
    <el-dialog
      title="编辑角色"
      center
      :visible.sync="editRoleDialog"
      width="600px"
      @close="clearForm('editRoleForm')"
      custom-class="add-dialog"
    >
      <el-form
        ref="editRoleForm"
        :model="editRoleForm"
        :rules="editRoleFormRules"
      >
        <el-form-item label="角色名称" label-width="80px" prop="roleName">
          <el-input
            v-model="editRoleForm.roleName"
            autocomplete="off"
            placeholder="请编辑角色名称"
          ></el-input> </el-form-item
        ><br />

        <el-form-item label="备注" label-width="80px">
          <el-input
            v-model="editRoleForm.remark"
            autocomplete="off"
            placeholder="请填写备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editRole('editRoleForm')"
          >确 定</el-button
        >
        <el-button @click="editRoleDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 删除角色弹窗 -->
    <el-dialog
      title="删除角色"
      center
      :visible.sync="deleteRoleDialog"
      width="30%"
    >
      <div>确定删除该角色？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onRoleDelete">确 定</el-button>
        <el-button @click="deleteRoleDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 添加用户到角色弹窗 -->
    <el-dialog
      title="添加用户到角色"
      center
      :visible.sync="addUserDialog"
      width="60%"
    >
      <el-table
        :data="addUsertableData"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
        @selection-change="handleTableSelectionChange2"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          type="index"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column prop="username" label="账号" align="center">
        </el-table-column>
        <el-table-column prop="realName" label="真实姓名" align="center">
        </el-table-column>
        <el-table-column prop="tel" label="电话" align="center">
        </el-table-column>
        <el-table-column prop="deptName" label="所属机构" align="center">
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          :total="totalSize2"
          :current-page="currentPage2"
          :page-size="pageSize2"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :page-sizes="[10, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUserByRoleSave">确 定</el-button>
        <el-button @click="addUserDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 从角色中删除用户弹窗 -->
    <el-dialog
      title="从角色中删除用户"
      :visible.sync="deleteUserDialog"
      width="30%"
      center
    >
      <div>确定删除该用户？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onUserDelete">确 定</el-button>
        <el-button @click="deleteUserDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data: function () {
    return {
      isactive: "",
      // 全选
      isIndeterminate: false,
      checkAllMenus: false,
      // 弹窗
      createRoleDialog: false,
      editRoleDialog: false,
      deleteRoleDialog: false,
      addUserDialog: false,
      deleteUserDialog: false,
      //角色列表
      roleList: [],
      tableProp: [],
      tableData: [],
      menuTree: [],
      menuAllIds: [],
      addUsertableData: [],
      checkedKey: [],
      currentPage1: 1,
      pageSize1: 10,
      totalSize1: 0,
      currentPage2: 1,
      pageSize2: 10,
      totalSize2: 500,
      formLabelWidth: "80px",
      getRole: {},
      AddUserform: {},
      multipleSelectionTable: [],
      multipleSelectionTable2: [],
      // 新增角色
      addRoleForm: {
        roleName: "",
        type: "",
        remark: "",
      },
      // 编辑角色
      editRoleForm: {
        roleName: "",
        type: "",
        remark: "",
      },
      defaultMenuProps: {
        children: "children",
        label: "permDesc",
      },
      activeName: "first",
      addRoleFormRules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
      },
      editRoleFormRules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
      },
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    $(".authManageNav").addClass("isactive");
    this.searchRole();
  },
  methods: {
    // 加载角色列表
    searchRole() {
      let that = this;
      $.ajax({
        url: "/zyk/c/auth/roleInfo/list",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          that.roleList = data.obj;
        },
      });
    },
    //新增显示出弹框，清空
    firstCreateRole() {
      this.createRoleDialog = true;
      this.addRoleForm = {
        roleName: "",
        remark: "",
        type: "",
      };
    },
    //编辑用户出弹框
    firstEditRole() {
      if (JSON.stringify(this.getRole) === "{}") {
        this.$message({
          message: "请选中具体的角色再编辑",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 0,
        });
      } else {
        this.editRoleDialog = true;
        this.editRoleForm = {
          roleName: this.getRole.roleName,
          type: this.getRole.type,
          remark: this.getRole.remark,
          id: this.getRole.id,
        };
      }
    },
    // 删除角色前确认
    deleteRolePre() {
      if (JSON.stringify(this.getRole) === "{}") {
        this.$message({
          message: "请选中具体的角色",
          type: "error",
          duration: 0,
          offset: 100,
          showClose: true,
        });
      } else {
        this.deleteRoleDialog = true;
      }
    },
    //首次添加用户到角色
    addUserByRole() {
      //判断是否选中角色
      this.AddUserform = {};
      // let that = this;
      if (!this.getRole.id) {
        this.$message({
          message: "请先选择角色",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else {
        this.addUserDialog = true;
        this.getRoleListRest();
      }
    },
    //新增角色
    createRole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          $.ajax({
            url: "/zyk/c/auth/roleInfo/add",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: that.addRoleForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "新增角色成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchRole();
                that.createRoleDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                  onClose: function () {
                    // that.noClick = false;
                  },
                });
              }
            },
          });
        } else {
          console.log("error !!");
          return false;
        }
      });
    },
    //编辑角色
    editRole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          // that.noClick = true;
          $.ajax({
            url: "/zyk/c/auth/roleInfo/update",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: that.editRoleForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "修改角色成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchRole();
                that.editRoleDialog = false;
                that.getRole = that.editRoleForm;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                  onClose: function () {
                    // that.noClick = false;
                  },
                });
              }
            },
          });
        } else {
          console.log("error !!");
          return false;
        }
      });
    },
    //删除角色
    onRoleDelete() {
      let that = this;
      // that.noClick = true;
      $.ajax({
        url: "/zyk/c/auth/roleInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: this.getRole.id },
        error: function (xhr) {
          if (xhr.responseText.indexOf("<title>登录") !== -1) {
            that.toLogin();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.getRole = {};
            that.isactive = "";
            that.searchRole();
            that.deleteRoleDialog = false;
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
              onClose: function () {
                // that.noClick = false;
              },
            });
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
              onClose: function () {
                // that.noClick = false;
              },
            });
          }
        },
      });
    },
    //加载角色的用户、菜单权限
    applyUserList(index, item) {
      this.isactive = index;
      this.getRole = item;
      let that = this;
      let params = {
        roleId: item.id,
        page: that.currentPage1,
        size: that.pageSize1,
      };
      this.subjectLoading = true;
      //加载用户列表
      $.ajax({
        url: "/zyk/auth/userInfo/selectUserByRole",
        type: "GET",
        contentType: "application/json;charset=utf-8",
        dataType: "json",
        data: params,
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.tableData = data.obj.list;
            that.totalSize1 = data.obj.total;
            that.currentPage1 = data.obj.pageNum;
          } else {
            that.$message({
              message: "获取用户失败",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
      // 获取菜单权限
      $.ajax({
        url: "/zyk/c/auth/permInfo/list",
        type: "GET",
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.menuTree = data.obj;
            that.menuAllIds = [];
            data.obj.forEach((value) => {
              that.menuAllIds.push(value.id);
            });
          } else {
            that.$message({
              message: "获取菜单权限失败",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
      // 获取当前的权限
      $.ajax({
        url: "/zyk/auth/permInfo/selectPermByRole",
        type: "GET",
        data: { roleId: that.getRole.id },
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.checkedKey = [];
            data.obj.forEach(function (value) {
              that.checkedKey.push(value.id);
            });
          } else {
            that.$message({
              message: "获取菜单权限失败",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    //显示剩余用户的列表
    getRoleListRest() {
      let that = this;
      $.ajax({
        url: "/zyk/auth/userInfo/selectUser2Role",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: {
          roleId: this.getRole.id,
          page: that.currentPage2,
          size: that.pageSize2,
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.addUsertableData = data.obj.list;
            that.totalSize2 = data.obj.total;
            that.currentPage2 = data.obj.pageNum;
            // that.listLoading = false
          } else {
            that.$message({
              message: "获取用户失败",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    //添加用户到角色保存
    addUserByRoleSave() {
      if (this.multipleSelectionTable2.length == 0) {
        this.$message({
          message: "请选中具体的用户",
          type: "error",
          offset: 100,
          duration: 0,
          showClose: true,
        });
      } else {
        let ids = this.multipleSelectionTable2.map((itemuser) => {
          return itemuser.id;
        });
        let that = this;
        // that.noClick = true;
        $.ajax({
          url: "/zyk/auth/roleInfo/addUsers",
          type: "POST",
          //contentType: 'application/json;charset=utf-8',
          dataType: "json",
          data: {
            roleId: this.getRole.id,
            userIds: ids.toString(),
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.reload();
            }
          },
          success: function (data) {
            if (data.code == 200) {
              that.$message({
                message: "添加用户成功",
                duration: 2000,
                showClose: true,
                type: "success",
                offset: 100,
              });
              that.addUserDialog = false;
              that.applyUserList(that.isactive, that.getRole);
            } else {
              that.$message({
                message: data.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                onClose: function () {
                  // that.noClick = false;
                },
              });
            }
          },
        });
      }
    },
    // 从角色中删除用户前确认
    deleteUserPre() {
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
          message: "请选中具体的用户",
          duration: 0,
          type: "error",
          offset: 100,
          showClose: true,
        });
      } else {
        this.deleteUserDialog = true;
      }
    },
    // 从角色中删除用户
    onUserDelete() {
      let ids = this.multipleSelectionTable.map((itemuser) => {
        return itemuser.id;
      });
      let that = this;
      // that.noClick = true;
      $.ajax({
        url: "/zyk/auth/roleInfo/removeUsers",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: {
          roleId: this.getRole.id,
          userIds: ids.toString(),
        },
        error: function (xhr) {
          if (xhr.responseText.indexOf("<title>登录") !== -1) {
            that.toLogin();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除用户成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.deleteUserDialog = false;
            that.applyUserList(that.isactive, that.getRole);
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
              onClose: function () {
                // that.noClick = false;
              },
            });
          }
        },
      });
    },
    changeNew(val) {
      console.log(val);
    },
    // 选中或取消选中单个权限按钮
    tableCheckboxChange(val, row) {
      if (val) {
        row.checked = true;
      }
    },
    //菜单全选
    handleCheckAllRightsMenus(val) {
      this.$refs.menuRightTree.setCheckedKeys(val ? this.menuAllIds : []);
    },
    //保存当前角色权限
    RightsSave() {
      let that = this;
      // if (false) {
      //   that.$message({
      //     message: "请选中具体的权限",
      //     type: "error",
      //     offset: 100,
      //     duration: 0,
      //     showClose: true,
      //   });
      // }
      let params = { roleId: that.getRole.id };
      var checkedNode = this.$refs.menuRightTree.getCheckedNodes(false, true);
      if (checkedNode && checkedNode.length > 0) {
        var checkMenuIds = [];
        checkedNode.forEach(function (value) {
          checkMenuIds.push(value.id);
        });
        params.permIds = checkMenuIds.join(",");
      }
      $.ajax({
        url: "/zyk/auth/roleInfo/addPerms",
        type: "POST",
        dataType: "json",
        data: params,
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "保存角色权限成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            //  that.searchRole()
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    clearForm(formName) {
      this.$refs[formName].clearValidate();
    },
    // 选择用户表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 添加选择用户表格某一行
    handleTableSelectionChange2(val) {
      this.multipleSelectionTable2 = val;
    },

    // 分页，角色的用户
    handleSizeChange(val) {
      this.pageSize1 = val;
      this.applyUserList(this.isactive, this.getRole);
    },
    handleCurrentChange(val) {
      this.currentPage1 = val;
      this.applyUserList(this.isactive, this.getRole);
    },
    // 分页，添加剩余的用户
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getRoleListRest();
      this.applyUserList(this.isactive, this.getRole);
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.getRoleListRest();
      this.applyUserList(this.isactive, this.getRole);
    },
  },
};
</script>

<style>
/* 角色管理 */

.rolepart-left {
  width: 250px;
  padding: 5px;
  position: fixed;
  margin-top: 5px;
  height: calc(100% - 100px);
}

.rolepart-left-title {
  width: 100%;
  padding: 20px 0 5px 0px;
}

#rolepart .button-box {
  padding: 5px 0 10px 0px;
  border-bottom: 1px solid #ccc;
}

.role-list {
  margin-top: 5px;
  height: calc(100% - 50px);
}

.role-item.active,
.role-item.active:hover,
.role-list-detail li:hover {
  background-color: #ecf0ef;
}

.role-list-detail {
  height: 500px;
  padding: 5px;
  font-size: 13px;
  height: calc(100% - 50px);
  overflow: auto;
}

.role-list-detail li {
  height: 30px;
  cursor: pointer;
}

.rolepart-right .roleMenuBox .upButton .el-checkbox {
  margin-left: 10px !important;
}

.downContent .el-tree-node__children .el-tree-node__content {
  float: left;
}
</style>